module.exports = __webpack_public_path__ + "img-dashboard/register/icon-setting.580ddb64.png";